import React, { useEffect } from 'react';
import { MainTable } from '../../../Components/Macro/MainTable/MainTable';
import Add from './Add';
import Edit from './Edit';
import { useVideoCat } from './VideoCatState';

function VideoCat() {
    let {cats, columns, setCats, delCat, setEd} = useVideoCat()
    useEffect(() => {
        setCats()
    }, [])
    return (
        <>
            <MainTable 
                pageTitle={"Video Kategoriyalari"}
                add={<Add />}
                edit={<Edit />}
                defkey={'id'}
                pcolumns={columns}
                pdata={cats}
                editTitle={"Matni"}
                onDelete={(_, id) => {
                    delCat(id.id)
                }}
                onEdit={(data) => {
                    setEd(data)
                }}
                setEd={setEd}
            />
        </>
    );
}

export default VideoCat;